import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

const PodcastListPage = () => {
  const { categoryName } = useParams();
  const [searchTerm, setSearchTerm] = useState('');
  
  // State to hold podcasts from the backend
  const [podcasts, setPodcasts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    
    // The API endpoint from your backend to get podcasts by category.
    const apiUrl = `/api/podcasts/summary_list_cat/${categoryName}`;

    fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        setPodcasts(data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error fetching podcasts:', error);
        setError(error.message);
        setIsLoading(false);
      });
  }, [categoryName]);

  // Filter based on the search term
  const filteredPodcasts = podcasts.filter(podcast =>
    podcast.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <div className="search-bar-container">
        <span className="material-icons search-icon">search</span>
        <input
          type="text"
          placeholder={`Search in ${categoryName}...`}
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {isLoading && <p className="text-center p-4">Loading podcasts...</p>}
      {error && <p className="error-message p-4">Error: {error}</p>}

      <div className="content-list">
        {!isLoading && !error && (
          filteredPodcasts.length > 0 ? (
            filteredPodcasts.map((item) => (
              // This will eventually link to a detail page for each podcast
              <Link to={`/podcasts/${item.id}`} key={item.id} className="content-card">
                <img 
                  src={item.thumbnail_url || 'https://placehold.co/300x180?text=No+Image'}
                  alt={item.title}
                  className="content-card-thumbnail"
                  onError={e => { e.target.onerror = null; e.target.src = 'https://placehold.co/300x180?text=No+Image'; }}
                />
                <div className="content-card-body">
                  <h3 className="content-card-title">{item.title}</h3>
                  <p className="content-card-description">{item.category}</p>
                </div>
              </Link>
            ))
          ) : (
            <p className="text-center text-gray-500 mt-8">No podcasts found in this category.</p>
          )
        )}
      </div>
    </div>
  );
};

export default PodcastListPage;
